module.exports = __webpack_public_path__ + "static/media/linkedin.3f987a71.svg";